<template>
  <default-layout>
    <vue-headful
      v-if="project && project.name"
      :title="pageTitle"
    />
    <back-button
      v-if="showBackButton && $vuetify.breakpoint.mdAndUp"
      :move-back="false"
      @click="goBack"
    />
    <vue-friendly-iframe
      :src="iframeSrc"
      class="panorama3"
      frameborder="0"
      gesture="media"
      allow="encrypted-media"
      allowfullscreen="allowfullscreen"/>
  </default-layout>
</template>

<script>
/* ============
 * Panoramas list Page
 * ============
 *
 * Page where the user can view the account information.
 */
import store from '@/store';
import { mapActions, mapGetters } from 'vuex';
import DefaultLayout from '@/layouts/Default.vue';
import VueFriendlyIframe from 'vue-friendly-iframe';
import { cdnPanoramasUrl } from '@/utils/urls';
import BackButton from '@/components/BackButton';
import VueHeadful from 'vue-headful';

// Vue.component('vue-friendly-iframe', VueFriendlyIframe);

export default {
  /**
   * The name of the page.
   */
  name: 'PanoramaSingle',

  /**
   * The components that the page can use.
   */
  components: {
    BackButton,
    DefaultLayout,
    'vue-friendly-iframe': VueFriendlyIframe,
    VueHeadful,
  },
  beforeMount() {
    if (!store.state.panoramas.panoramas.length) {
      store.dispatch('panoramas/load', { order: this.$route.params.order });
    }
  },
  computed: {
    ...mapGetters('project', ['project', 'pages', 'panoramaGroups']),
    ...mapGetters('panoramas', ['panoramas']),
    iframeSrc() {
      return this.$route.query.iframeSrc
        ? this.$route.query.iframeSrc
        : cdnPanoramasUrl(`product/panorama/${this.$route.params.panoramaOrderId}?exploremore=0`);
    },
    showBackButton() {
      const PANO_LIST = this.panoramas.filter(pano => pano.page_id == this.$route.params.id);
      return this.$routerHistory.hasPrevious() && PANO_LIST.length !== 1;
    },
    panoramaTitle() {
      const id = +this.$route.params.id;
      const pages = this.pages || [];
      const pageById = pages.find(p => p && +p.id === id);
      if (pageById && pageById.label) {
        return this.$t ? this.$t(pageById.label) : pageById.label;
      }
      return this.$t ? this.$t('Panoramas') : 'Panoramas';
    },
    currentPanorama() {
      const panoId = +this.$route.params.panoramaOrderId;
      if (!Array.isArray(this.panoramas)) return null;
      return this.panoramas.find(p => +p.id === panoId) || null;
    },
    pageTitle() {
      const base = this.project && this.project.name ? `${this.project.name} | ${this.panoramaTitle}` : this.panoramaTitle;
      const panoName = this.currentPanorama && this.currentPanorama.name;
      return panoName ? `${base} | ${panoName}` : base;
    },
  },
  methods: {
    ...mapActions('panoramas', ['getUnitByPanoramaId']),
    goBack() {
      this.$router.push({ path: this.$routerHistory.previous().path });
    },
  },
};
</script>

<style>
.panorama3 {
  position: fixed;
  top: var(--app-bar-height);
  left: 0;
  right: 0;
  bottom: 0;
}

.panorama3 iframe {
  width: 100%;
  height: 100%;
}

.fab-back-button {
  position: fixed;
  z-index: 20;

  top: var(--app-main-top);
  left: 15px;
  border-radius: 28px;
  width: 56px;
  height: 56px;
}
</style>
